import { render, staticRenderFns } from "./BoxesIcon.vue?vue&type=template&id=3e059bcc&"
import script from "./BoxesIcon.vue?vue&type=script&lang=js&"
export * from "./BoxesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports